import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from "../redux/reducers/authSlice";
import axios from "axios";
import { baseUrl } from "../redux";
import Loader from "../components/loader/loader";
import toast, { Toaster } from "react-hot-toast";
import logo from "../assets/logo.png";
import loginImg from "../assets/login_img.png";
import { FiEye, FiEyeOff, FiArrowLeft } from "react-icons/fi";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const userData = {};
    formData.forEach((value, key) => (userData[key] = value));
    setLoading(true);
    try {
      const response = await axios.post(`${baseUrl}/signin`, userData);
      if (response.data.status === true) {
        dispatch(login(response.data));
        toast.success(response.data.message || "Login successful!");
        navigate("/");
      } else {
        toast.error(response.data.message || "Login failed");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen w-full flex flex-col items-center justify-center relative px-4"
      style={{
        backgroundImage: `url(${loginImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Toaster position="top-right" />
      <Loader loading={loading} />

      {/* Full-page overlay */}
      <div className="absolute inset-0 bg-[#3d184e]/70" />

      {/* Back to home — top left */}
      <div className="absolute top-5 left-6 z-10">
        <Link
          to="/"
          className="flex items-center gap-1.5 text-white/80 hover:text-white text-sm bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-full transition-colors"
        >
          <FiArrowLeft />
          Back to Home
        </Link>
      </div>

      {/* Login card */}
      <div className="relative z-10 w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden">
        {/* Card header */}
        <div className="bg-[#3d184e] px-8 py-6 flex flex-col items-center">
          <img src={logo} alt="Logo" className="h-10 w-auto mb-3" />
          <h1 className="text-white font-bold text-xl">Revenue Pro Planner</h1>
          <p className="text-gray-400 text-xs mt-1">Sign in to your account</p>
        </div>

        {/* Card body */}
        <div className="px-8 py-8">
          <form onSubmit={handleSubmit} className="space-y-5">
            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">
                Email address
              </label>
              <input
                type="email"
                name="email"
                required
                placeholder="you@example.com"
                className="w-full border-2 border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-teal-500 transition-colors"
              />
            </div>

            {/* Password */}
            <div>
              <div className="flex items-center justify-between mb-1.5">
                <label className="text-sm font-medium text-gray-700">Password</label>
                <Link
                  to="/forgot-password"
                  className="text-xs text-teal-600 hover:underline"
                >
                  Forgot password?
                </Link>
              </div>
              <div className="relative">
                <input
                  type={showPass ? "text" : "password"}
                  name="password"
                  required
                  placeholder="Enter your password"
                  className="w-full border-2 border-gray-200 rounded-xl px-4 py-2.5 pr-11 text-sm focus:outline-none focus:border-teal-500 transition-colors"
                />
                <button
                  type="button"
                  onClick={() => setShowPass((p) => !p)}
                  className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-gray-600"
                >
                  {showPass ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-teal-600 hover:bg-teal-700 disabled:opacity-60 text-white font-semibold py-3 rounded-xl text-sm transition-colors"
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>

          <p className="text-center text-gray-400 text-xs mt-6">
            Don't have an account?{" "}
            <Link to="/trial" className="text-teal-600 font-medium hover:underline">
              Start your free 7-day trial
            </Link>
          </p>
        </div>
      </div>

      {/* Bottom credit */}
      <p className="relative z-10 text-white/40 text-xs mt-6">
        © {new Date().getFullYear()} Revenue Pro Planner. All rights reserved.
      </p>
    </div>
  );
};

export default Login;
